import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Dashboard|Comments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

export type SPCandidateSystemActivityLocNames =
	| 'SPCandidateSystemActivityButtonAddComment'
	| 'SPCandidateSystemActivityButtonHideComments'
	| 'SPCandidateSystemActivityButtonShowComments'
	| 'SPCandidateSystemActivityTitleSection'
	| 'SPCandidateSystemActivityNotificationChangesSaved';

export const spCandidateSystemActivityLocs: LocDefs<SPCandidateSystemActivityLocNames> = {
	SPCandidateSystemActivityButtonAddComment: {
		defaultValue: 'Add Comment',
		description: 'Button on the candidate security dashboard for adding a candidate comment.',
		displayPath: `${pathStart}Add Comment Button`,
		displayType: 'Button',
		legacyName: 'Core/Candidates.SecurityDashboard.SystemActivity.Button.AddComment',
		...sharedProperties,
	},
	SPCandidateSystemActivityButtonHideComments: {
		defaultValue: 'Hide Comment History',
		description: 'Button to hide the candidate comments in the security dashboard.',
		displayPath: `${pathStart}Hide Button`,
		displayType: 'Button',
		legacyName: 'Core/Candidates.SecurityDashboard.SystemActivity.Button.HideComments',
		...sharedProperties,
	},
	SPCandidateSystemActivityButtonShowComments: {
		defaultValue: 'Show Comment History',
		description: 'Button to show the candidate comments in the security dashboard.',
		displayPath: `${pathStart}Show Button`,
		displayType: 'Button',
		legacyName: 'Core/Candidates.SecurityDashboard.SystemActivity.Button.ShowComments',
		...sharedProperties,
	},
	SPCandidateSystemActivityTitleSection: {
		defaultValue: 'System Activity',
		description: 'Section title for candidate comment history on the dashboard.',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Core/Candidates.SecurityDashboard.SystemActivity.Title.Section',
		...sharedProperties,
	},
	SPCandidateSystemActivityNotificationChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Notification message for changes saved',
		displayPath: `${pathStart}Changes Saved`,
		displayType: 'Notification',
		legacyName: 'Core/Candidates.Comments.Notification.ChangesSaved',
		...sharedProperties,
	},
};

export const spCandidateSystemActivityLocKeys = MapLocKeys<SPCandidateSystemActivityLocNames>(
	spCandidateSystemActivityLocs
);

export type SPCandidateSystemActivityLocType = LocMap<SPCandidateSystemActivityLocNames>;
